import React from 'react';
import { Box, Skeleton, useTheme } from '@mui/material';
import { Row, Col } from 'react-bootstrap';

const DashboardCardsSkeleton = ({ cardCount = 5 }) => {
  const theme = useTheme();
  
  return (
    <div className="px-4 pt-1">
      <Row
        className="main_content_container py-3 mt-2 d-flex align-items-center"
        style={{ 
          borderColor: theme.palette.divider 
        }}
      >
        {Array.from({ length: cardCount }).map((_, index) => (
          <Col
            key={index}
            style={{ 
              flex: `0 0 ${100 / cardCount}%`,
              borderColor: theme.palette.divider
            }}
            md={6}
            sm={12}
            className={`px-0 ${index < cardCount - 1 ? 'border-end border-2' : ''} h-100 py-2`}
          >
            <Row>
              <Col>
                <div className="ps-5">
                  <Skeleton 
                    variant="circular" 
                    width={24} 
                    height={24}
                  />
                </div>
              </Col>
              <Col>
                <div>
                  <Skeleton 
                    variant="text" 
                    width="60%" 
                    height={20}
                  />
                  <Skeleton 
                    variant="text" 
                    width="40%" 
                    height={32} 
                    sx={{ mt: 1 }}
                  />
                </div>
              </Col>
            </Row>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default DashboardCardsSkeleton;
